import { Button } from "react-bootstrap";

const ButtonTimer = ({ children, type, timerValue }) => {
  return (
    <Button type={type} disabled={timerValue > 0}>
      {children + (timerValue ? " (" + timerValue + ")" : "")}
    </Button>
  );
};

export default ButtonTimer;
